import { render, staticRenderFns } from "./RssSourceList.vue?vue&type=template&id=196566cb&scoped=true&"
import script from "./RssSourceList.vue?vue&type=script&lang=js&"
export * from "./RssSourceList.vue?vue&type=script&lang=js&"
import style0 from "./RssSourceList.vue?vue&type=style&index=0&id=196566cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196566cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VProgressCircular,VSpacer})
